<template>
  <div
    class="z-20 flex flex-col border-l border-[#e5e5e5] bg-white"
    :class="rootClasses"
  >
    <div class="p-4" :class="!collapsed && 'border-b border-[#e5e5e5]'">
      <div class="flex items-start justify-between gap-2">
        <template v-if="!collapsed">
          <div
            v-if="model"
            class="text-[18px] font-medium leading-[24px] text-gray-800 line-clamp-4"
          >
            {{ model.title }}
          </div>
          <Skeleton v-else class="h-4 w-[148px]" />
        </template>
        <button
          type="button"
          class="shrink-0 cursor-pointer text-gray-800"
          @click="platformStore.toggleSidebarCollapse"
        >
          <CollapseIcon
            class="size-[18px]"
            :class="collapsed && 'rotate-180'"
          />
        </button>
      </div>

      <Button
        v-if="model?.share && !collapsed"
        class="mt-[18px]"
        variant="stroke"
        :icon="ShareIcon"
        :disabled="model.share.disabled"
        @click="model.share.onClick"
      >
        Share
      </Button>
    </div>

    <div v-if="!collapsed" class="flex-1 overflow-y-auto">
      <SidebarSection title="Information" :icon="InfoIcon">
        <template v-if="model">
          <SidebarThumbnail class="mb-6" :thumbnail="model.thumbnail" />
          <SidebarInfoRow
            v-for="(row, index) in model.rows"
            :key="index"
            :row="row"
          />
        </template>
        <Skeleton v-else class="h-[168px] w-full rounded-md" />
      </SidebarSection>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Button, Skeleton } from '@dacr/library'
import { CollapseIcon, ShareIcon, InfoIcon } from '@dacr/icons'

import { usePlatformStore } from '@/shared/stores/platform'
import { useDevice } from '@/shared/composables/useDevice'
import SidebarSection from './SidebarSection.vue'
import SidebarThumbnail from './SidebarThumbnail.vue'
import SidebarInfoRow from './SidebarInfoRow.vue'
import type { SidebarModel } from './types'

defineProps<{ model: SidebarModel | null }>()

const platformStore = usePlatformStore()
const device = useDevice()

const collapsed = computed(() => platformStore.isSidebarCollapsed)

const rootClasses = computed(() =>
  collapsed.value
    ? 'min-w-[50px] max-w-[50px]'
    : {
        'min-w-[330px] max-w-[330px]': true,
        'tablet-h:[box-shadow:0_0_20px_rgba(0,0,0,0.1)]':
          device.isTabletHorizontal.value,
        'tablet-h:[clip-path:inset(0_0_0_-20px)]':
          device.isTabletHorizontal.value,
      }
)
</script>
